import React from 'react';
import { Link } from 'react-router-dom';
import styles from './HeroBookDemoCta.module.css';

const CONTACT_FORM_HASH = '#lummo-demo-form';

const HeroBookDemoCta: React.FC = () => (
  <div className={styles.wrap}>
    <Link to={`/contact${CONTACT_FORM_HASH}`} className={styles.link}>
      Book a demo
    </Link>
  </div>
);

export default HeroBookDemoCta;
